import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { dateAsString, dateTimeAsString } from '../../shared/date.helper';

@Component({
  selector: 'app-unpinned-flags',
  templateUrl: './unpinned-flags.component.html',
  styleUrls: ['./unpinned-flags.component.scss'],
})
export class UnpinnedFlagsComponent implements OnInit, OnDestroy {
  constructor() {}

  get showOnlyFlagsWithPictures() {
    return this._showOnlyFlagsWithPictures;
  }

  _showOnlyFlagsWithPictures = false;

  @Output() flagPinned = new EventEmitter();
  @Output() close = new EventEmitter();

  dateAsString = dateAsString;
  dateTimeAsString = dateTimeAsString;

  @Input() picture;
  @Input() pictureAnswer;
  @Input() flags;

  answer: any;

  allFlags = [];
  filteredFlags = [];
  totalFlags = 0;
  scoresEnabled = true;

  destroyed;

  updateFilteredFlags() {
    if (this.showOnlyFlagsWithPictures) {
      const ret = this.allFlags.map(section => ({ ...section }));

      // actual filters
      ret.forEach(section => {
        section.flags = section.flags.filter(f => {
          return f.hasPictures;
        });
      });

      this.filteredFlags = ret.filter(s => s.flags.length);
    } else {
      this.filteredFlags = this.allFlags;
    }
  }

  ngOnDestroy() {
    this.destroyed = true;
  }

  buildingIndex(flag) {
    if (this.answer && Array.isArray(this.answer)) {
      const answer = this.answer.find(a => a.id === flag.answerId);
      if (answer) {
        return answer.buildingIndex;
      }
    }
  }

  violations() {
    const flags = this.getCurrentFlags();
    return flags.filter(flag => {
      return (flag?.subtype?.type?.name === 'Violation' || flag?.subtype?.type?.name === 'Legacy') && !flag.pictureId;
    });
  }

  discrepancies() {
    const flags = this.getCurrentFlags();
    return flags.filter(flag => {
      return flag?.subtype?.type?.name === 'Discrepancy' && !flag.pictureId;
    });
  }

  getCurrentFlags() {
    const pictureAnswer = this.picture?.answer ? this.picture.answer : this.pictureAnswer;
    if (!pictureAnswer) {
      return [];
    }
    if (Array.isArray(pictureAnswer)) {
      return pictureAnswer.reduce((flags, answer) => {
        return [...flags, ...(answer?.flags || [])];
      }, []);
    } else {
      return pictureAnswer?.flags || [];
    }
  }

  getFlagHighlightClass(flag) {
    const score = this.scoresEnabled ? flag.score : 0;
    return {
      red: score >= 100,
      orange: score >= 5 && score < 100,
      amber: score >= 1 && score < 5,
      blue: score < 1,
    };
  }

  flagReleased(flag, e) {
    setTimeout(async () => {
      this.flagPinned.emit(flag);
    }, 0);
  }

  async ngOnInit() {
    this.updateFilteredFlags();
  }

  emitClose() {
    this.close.emit();
  }
}
